<template>
<div class="contentBox liveHistoryPage">
    <div class="pageTitle">
        <!--<h1>直播历史</h1>-->
        <el-steps :active="4" simple finish-status="wait" style="padding-left: 0;width:100%">
            <el-step title="编辑" icon="el-icon-edit" @click.native="jumpNavPage('/live/edit')"></el-step>
            <el-step title="发起直播" icon="el-icon-video-play" @click.native="jumpNavPage('/live/launch')"></el-step>
            <el-step title="分享" icon="el-icon-share" @click.native="jumpNavPage('/live/share')"></el-step>
            <el-step title="监控统计" icon="el-icon-data-analysis" @click.native="jumpNavPage('/live/statistics')"></el-step>
            <el-step title="录播" icon="el-icon-video-camera"></el-step>
        </el-steps>
    </div>
    <div class="historyBox">
        <div class="top" v-if="lives.length"></div>
        <template v-for="(item, index) in lives">
            <div class="historyItem" :key="index">
                <span class="date subText">{{item.date}}</span>
                <i class="videoBtn"></i>
                <div class="listImgIcon">
                    <img :src="item.poster" alt="" />
                </div>
                <div class="liveInfo">
                    <el-badge :value="item.statusName" class="item" :type="item.badgeType">
                        <a herf="javascript:;" class="livename">{{item.title}}</a>
                    </el-badge>
                    <div class="descInfo">
                        <span class="subText">大小：{{item.size}}</span><span class="subText">长度：{{item.duration}}</span>
                        <span class="subText">尺寸：{{item.resolution}}</span>
                    </div>
                    <div class="statInfo" v-if="['HIDDEN', 'STOPPED', 'PUBLISHED'].includes(item.status)">
                        <span class="subText">录播人次：{{item.visitCount}}</span><span class="subText">录播流量：{{item.recordFlow}}</span>
                        <span class="subText">直播人数：{{item.liveUserCount}}</span><span class="subText">直播流量：{{item.liveFlow}}</span>
                    </div>
                    <div class="ip">推流IP：{{item.clientIp}}</div>
                </div>
                <div class="operateBox">
                    <div class="dates">{{item.dateTime}}</div>
                    <div class="imgBox">
                        <i class="el-icon-video-play" v-if="['LIVING','HIDDEN', 'PUBLISHED'].includes(item.status)" title="播放" @click="playRecord(item.liveId)"></i>
                        <i class="el-icon-data-line" v-if="'LIVING' !== item.status" title="直播时段统计" @click="statLive(item.liveId)" ></i>
                        <i class="el-icon-edit" v-if="['HIDDEN', 'PUBLISHED'].includes(item.status)" title="编辑标题" @click="editTitle(item)"></i>
                        <i class="el-icon-close" v-if="'PUBLISHED' === item.status" title="下线" @click="hideLive(item)"></i>
                        <i class="el-icon-check" v-if="'HIDDEN' === item.status" title="上线" @click="publishLive(item)"></i>
                        <el-popconfirm v-if="['HIDDEN', 'PUBLISHED'].includes(item.status)" title="确定要删除录播吗？" @confirm="deleteRecord(item)">
                            <i class="el-icon-delete" slot="reference" title="删除"></i>
                        </el-popconfirm>
                    </div>
                </div>
            </div>
            <div class="blank" :key="item.liveId" v-if="index != item.length - 1"></div>
        </template>
        <div class="bottom" v-if="lives.length>0"></div>
    </div>
    <button class="loadingMore" @click="loadMore()" v-if="lives.length < totalCount">加载更多</button>
    <div class="listPrompt">
        <!-- 无列表显示 -->
        <div class="noListMessIcon NoInformation" v-if="lives.length === 0">暂无信息</div>
        <!-- 列表已加载完毕 -->
        <div class="noListMessIcon ToLoadInformation" v-if="lives.length>0 && lives.length === totalCount">已经没有了哦o(*￣︶￣*)o</div>
    </div>

    <el-drawer
            title="播放"
            :visible.sync="showPlayer"
            :wrapperClosable="false"
            size="640px"
            @close="playerClosed">
        <vue-aliplayer-v2 :source="source" ref="AliplayerV2" :options="playerOptions"/>
    </el-drawer>
    <el-dialog
        title="修改名称"
        :visible.sync="editDialogVisible"
        width="480px">
        <span>
            <el-input ref="liveTitle"
                placeholder="请输入新标题"
                v-model="currentLive.title">
                <i slot="prefix" class="el-input__icon el-icon-film"></i>
            </el-input>
        </span>
        <span slot="footer" class="dialog-footer">
            <el-button @click="editDialogVisible = false">取 消</el-button>
            <el-button type="primary" @click="saveLiveTitle" :loading="savingTitle">确 定</el-button>
        </span>
    </el-dialog>
</div>
</template>

<script>
    import common from '../../common.vue';
    import moment from 'moment';
    import 'moment/locale/zh-cn';
    // 每页条数
    const PAGE_SIZE = 10;
    const STATUS_MAPPER = {
        'LIVING': '直播中',
        'STOPPED': '已停止',
        'RECORDING': '录制生成中',
        'HIDDEN': '已隐藏',
        'PUBLISHED': '已发布'
    };
    const BADGE_TYPE_MAPPER = {
        'LIVING': 'primary',
        'STOPPED': 'info',
        'RECORDING': 'warn',
        'HIDDEN': 'info',
        'PUBLISHED': 'success'
    };
    // 删除录播报错映射表
    const REMOVE_ERROR_MAPPER = {
        "0": "",
        "-1": "登录已过期",
        "-2": "访问被拒绝",
        "-3": "无效的直播"
    };

    export default {
        name: "LiveHistory",
        data() {
            return {
                // 是否显示播放器
                showPlayer: false,
                // 是否显示编辑标题窗口
                editDialogVisible: false,
                // 是否正在保存直播标题
                savingTitle: false,
                // 当前编辑录播
                currentLive: {},
                // 播放器配置
                playerOptions: {
                    isLive: false,
                    "skinLayout": [
                        {
                            "name": "bigPlayButton",
                            "align": "blabs",
                            "x": 30,
                            "y": 80
                        },
                        {
                            "name": "H5Loading",
                            "align": "cc"
                        },
                        {
                            "name": "infoDisplay"
                        },
                        {
                            "name": "tooltip",
                            "align": "blabs",
                            "x": 0,
                            "y": 56
                        },
                        {
                            "name": "thumbnail"
                        },
                        {
                            "name": "controlBar",
                            "align": "blabs",
                            "x": 0,
                            "y": 0,
                            "children": [
                                {
                                    "name": "progress",
                                    "align": "blabs",
                                    "x": 0,
                                    "y": 44
                                },
                                {
                                    "name": "playButton",
                                    "align": "tl",
                                    "x": 15,
                                    "y": 12
                                },
                                {
                                    "name": "timeDisplay",
                                    "align": "tl",
                                    "x": 10,
                                    "y": 7
                                },
                                {
                                    "name": "fullScreenButton",
                                    "align": "tr",
                                    "x": 10,
                                    "y": 12
                                },
                                {
                                    "name": "subtitle",
                                    "align": "tr",
                                    "x": 15,
                                    "y": 12
                                },
                                {
                                    "name": "setting",
                                    "align": "tr",
                                    "x": 15,
                                    "y": 12
                                },
                                {
                                    "name": "volume",
                                    "align": "tr",
                                    "x": 5,
                                    "y": 10
                                }
                            ]
                        }
                    ]
                },
                // 播放链接
                source: '',
                // 直播历史列表
                lives: [],
                // 总计历史条数
                totalCount: 0
            };
        },
        methods: {
            jumpPage(path) {
                this.$router.push(`${path}`);
            },
            focusInput() {
                this.searchFocus = true;
            },
            inputBlur() {
                this.searchFocus = false;
            },
            emptySearchVal() {
                this.searchVal = '';
            },

            setCurrentTotal() {
                this.currentTotal = this.lives.length;
                this.totleIndex = Math.ceil(this.currentTotal / this.pageSize);
                console.log(this.totleIndex)
            },

            // 加载更多
            loadMore() {
                this.getChannelLives(Math.ceil(this.lives.length/PAGE_SIZE));
            },
            // 获取直播历史
            getChannelLives(pageIndex){
                let _this = this, index = pageIndex || 0;
                if(index ===0){ _this.lives = []; }
                _this.$axios.post(common._BASE_ + '/live/channelLives',
                    this.$qs.stringify({channelId: _this.channelId, pageIndex: index})).then(function (res) {
                    let r = res.data;
                    if (r && r.lives) {
                        _this.lives = _this.lives.concat(_this.formatLives(r.lives));
                    }
                    _this.totalCount = r.total;
                });
            },
            // 格式化直播历史
            formatLives(lives){
                let list = lives || [];
                moment.locale('zh-ch');
                list.forEach(function(item){
                    item.resolution = item.width + ' x ' + item.height;
                    item.statusName = STATUS_MAPPER[item.status] || '未知状态';
                    // 如果在直播、停止和生成中时，不显示大小
                    item.size = ['LIVING', 'STOPPED', 'RECORDING'].includes(item.status)? '-' : common.formatSize(item.size).join(' ');
                    item.duration = 'LIVING' === item.status? '-': common.seconds2duration(item.duration);
                    item.startTime = moment(item.startTime).format("YYYY-MM-DD HH:mm");
                    item.date = moment(item.startTime).format("MM-DD");
                    if(['HIDDEN', 'STOPPED', 'PUBLISHED'].includes(item.status)){
                        item.visitCount = common.addCommas(item.visitCount);
                        item.liveUserCount = common.addCommas(item.liveUserCount);
                        item.recordFlow = common.formatSize(item.recordFlow).join(' ');
                        item.liveFlow = common.formatSize(item.liveFlow).join(' ');
                    }
                    item.badgeType = BADGE_TYPE_MAPPER[item.status];
                });
                return list;
            },
            /**
             * 跳至统计页面
             * @param lid 直播Id
             */
            statLive(lid){
                console.info(lid);
                this.$router.push({
                    path: '/live/statistics',
                    name: 'Statistics',
                    params: { lid: lid },
                    query: {lid: lid}
                });
            },
            // 播放录播
            playRecord(lid) {
                let _this = this;
                _this.showPlayer = true;
                this.source !== '' && this.$refs.AliplayerV2.pause();
                // 请求播放链接
                _this.$axios.post(common._BASE_ + 'live/getLiveUri',
                    this.$qs.stringify({liveId: lid})).then(function (res) {
                    let r = res.data;
                    if (r.code !== 0) {
                        _this.$message({
                            message: r.message,
                            type: 'error'
                        })
                    } else {
                        _this.playerOptions.isLive = !!r.isLive;
                        if(r.vid && r.auth){
                            // 使用vid方式播放
                            _this.source = null;
                            _this.playerOptions.vid = r.vid;
                            _this.playerOptions.playauth = r.auth;
                            _this.playerOptions.format = "m3u8";
                            _this.playerOptions.mediaType = "video";
                            _this.$refs.AliplayerV2.init();
                            _this.$refs.AliplayerV2.play();
                        }else{
                            _this.source = r.uri;
                        }
                    }
                });
            },
            playerClosed() {
                console.info('player closed');
                this.$refs.AliplayerV2.pause();
                //this.$refs.AliplayerV2.dispose();
            },
            // 删除录播
            deleteRecord(live){
                if(!live){ return; }
                let _this = this;
                _this.$axios.post(common._BASE_ + '/live/removeLive',
                    this.$qs.stringify({liveId: live.liveId})).then(function (res) {
                    let r = res.data;
                    if (r.code !== 0) {
                        _this.$notify({
                            title: '错误',
                            message: REMOVE_ERROR_MAPPER[r.code + ''],
                            type: 'error'
                        });
                    }else{
                        // 更新列表中录播的状态
                        _this.updateLiveStatus(live.liveId, 'STOPPED');
                    }
                });
            },
            // 更新本地录播状态
            updateLiveStatus(liveId, status){
                for(let i=0; i<this.lives.length; i++){
                    if(this.lives[i].liveId === liveId){
                        this.lives[i].status = status;
                        this.lives[i].badgeType = BADGE_TYPE_MAPPER[status];
                        this.lives[i].statusName = STATUS_MAPPER[status];
                        break;
                    }
                }
            },
            // 编辑录播标题
            editTitle(live){
                if(!live){ return; }

                this.currentLive = live;
                this.editDialogVisible = true;
                let _this = this;
                setTimeout(function(){
                    _this.$refs.liveTitle.select();
                }, 100);

            },
            // 保存录播标题
            saveLiveTitle(){
                let _this = this;
                _this.savingTitle = true;
                _this.$axios.post(common._BASE_ + '/live/saveLive',
                    this.$qs.stringify({liveId: _this.currentLive.liveId, title: _this.currentLive.title})).then(function (res) {
                    _this.savingTitle = false;
                    let r = res.data;
                    if (r.code !== 0) {
                        _this.$notify({
                            title: '错误',
                            message: REMOVE_ERROR_MAPPER[r.code + ''],
                            type: 'error'
                        });
                    }else{
                        // 更新列表中录播标题
                        _this.editDialogVisible = false;
                    }
                });
            },
            // 发布录播
            publishLive(live){
                this.setLiveStatus(live, common._BASE_ + '/live/publishLive');
            },
            // 隐藏录播
            hideLive(live){
                this.setLiveStatus(live, common._BASE_ + '/live/hideLive');
            },
            // 设置录播状态
            setLiveStatus(live, uri){
                let _this = this;
                _this.$axios.post(uri,
                    this.$qs.stringify({liveId: live.liveId})).then(function (res) {
                    let r = res.data;
                    if (r.code !== 0) {
                        _this.$notify({
                            title: '错误',
                            message: REMOVE_ERROR_MAPPER[r.code + ''],
                            type: 'error'
                        });
                    }else{
                        _this.updateLiveStatus(live.liveId, live.status === 'PUBLISHED'? 'HIDDEN': 'PUBLISHED');
                    }
                });
            },
            jumpNavPage(path) {
                this.$router.push({
                    path: path,
                    params: { cid: this.channelId },
                    query: {cid: this.channelId}
                });
            }
        },
        mounted() {
            let cid = this.$route.params.cid || this.$route.query.cid;
            if (cid && parseInt(cid) > 0) {
                this.channelId = cid;
                this.getChannelLives(0);
            }
            //this.setCurrentTotal();
        },
        beforeDestroy() {
            if (this.$refs.AliplayerV2) {
                this.$refs.AliplayerV2.dispose();
            }
        }
    };
</script> 

<style lang="less">
.liveHistoryPage {
    .pageTitle {
        margin-bottom: 20px;
        display: flex;
        align-items: center;
        justify-content: space-between;

        .searchBox {
            position: relative;
            display: flex;

            .search {
                width: 437px;
                height: 40px;
                border: solid 1px #e8e8e8;
                background: #fff;
                border-radius: 6px;
                padding-left: 12px;
            }

            .search:focus {
                border: 1px solid #306ff6;
            }

            .searchHistoryIcon {
                position: absolute;
                right: 90px;
                // top: 12px;
                cursor: pointer;
            }
        }

        .clearBtn {
            width: 80px;
            height: 40px;
            background: #076eff;
            border-radius: 6px;
            font-size: 16px;
            font-weight: 400;
            color: #ffffff;
            margin-left: 10px;
        }

        .clearBtn:hover {
            background: #4aa3f8;
        }
    }

    .historyBox {
        width: 1210px;
        background: #ffffff;
        border: 1px solid #e8e8e8;
        border-radius: 0px;

        .top {
            height: 34px;
            position: relative;
        }

        .top::before {
            position: absolute;
            content: "";
            width: 1px;
            height: 34px;
            background: #e4e6e6;
            left: 83px;
        }

        .bottom {
            height: 42px;
            position: relative;
        }

        .bottom::before {
            position: absolute;
            content: "";
            width: 1px;
            height: 42px;
            background: #e4e6e6;
            left: 83px;
        }

        .blank {
            height: 20px;
            position: relative;
        }

        .blank::before {
            position: absolute;
            content: "";
            width: 1px;
            height: 20px;
            background: #e4e6e6;
            left: 83px;
        }

        .historyItem {
            width: 1154px;
            height: 91px;
            margin-left: 23px;
            position: relative;
            padding-left: 83px;
            display: flex;

            .videoBtn {
                position: absolute;
                width: 30px;
                height: 30px;
                background: url("../../assets/playIcon.svg") no-repeat center center;
                background-size: 100% 100%;
                border-radius: 50%;
                position: absolute;
                top: 30px;
                left: 146px;
                z-index: 2;
                -webkit-transition: all 0.2s ease-out;
                -o-transition: all 0.2s ease-out;
                -moz-transition: all 0.2s ease-out;
                transition: all 0.2s ease-out;
                opacity: 0;
                -webkit-transform: scale(1.2);
                -moz-transform: scale(1.2);
                -ms-transform: scale(1.2);
                -o-transform: scale(1.2);
                transform: scale(1.2);
                cursor: pointer;
            }

            .subText {
                display: inline-block;
                font-size: 12px;
                font-weight: 400;
                color: #a2a9ab;
            }

            .date {
                position: absolute;
                top: 0;
                left: 0;
            }

            .listImgIcon {
                width: 160px;
                height: 90px;
                border-radius: 6px;
                overflow: hidden;

                img {
                    width: 100%;
                    transition: all 0.6s;
                    -webkit-transition: all 0.6s;
                }
            }

            .liveInfo {
                margin-left: 18px;

                .livename {
                    /*width: 750px;*/
                    font-size: 14px;
                    line-height: 21px;
                    color: #221816;
                    margin-bottom: 3px;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                    display: block;
                    cursor: pointer;
                }

                .livename:hover {
                    color: #306ff6;
                }

                .descInfo, .statInfo {
                    span {
                        margin: 0 20px;
                        width: 150px;
                    }
                }

                .ip {
                    font-size: 12px;
                    font-weight: 400;
                    line-height: 21px;
                    color: #221816;
                    margin-top: 17px;
                }
            }

            .operateBox {
                width: 110px;
                height: 100%;
                position: absolute;
                right: 0;
                top: 0;
                font-size: 12px;
                font-weight: 400;
                line-height: 21px;
                color: #221816;
                text-align: right;

                .imgBox {
                    margin-top: 70px;

                    span {
                        width: 12px;
                        height: 12px;
                        display: inline-block;
                        cursor: pointer;
                    }

                    i{
                        font-size: 14px;
                        font-weight: 400;
                        cursor: pointer;
                        color: #a2a9ab;
                        margin-left: 8px;
                    }
                    i:hover{
                        color:#306ff6;
                    }
                }
            }
        }

        .historyItem:hover {
            .listImgIcon {
                img {
                    transform: scale(1.06);
                    -webkit-transform: scale(1.06);
                }
            }

            .videoBtn {
                opacity: 1;
                -webkit-transform: scale(1);
                -moz-transform: scale(1);
                -ms-transform: scale(1);
                -o-transform: scale(1);
                transform: scale(1);
            }

            .livename {
                color: #306ff6;
            }
        }

        .historyItem::before {
            position: absolute;
            content: "";
            width: 1px;
            height: 91px;
            background: #e4e6e6;
            left: 60px;
        }

        .historyItem::after {
            position: absolute;
            content: "";
            width: 14px;
            height: 14px;
            background: #f5f6f7;
            border: 1px solid #c1c5c5;
            border-radius: 50%;
            left: 53px;
            top: 0;
        }
    }

    .loadingMore {
        width: 110px;
        height: 30px;
        background: #ffffff;
        opacity: 1;
        border-radius: 4px;
        display: block;
        margin: 30px auto;
    }

    .loadingMore:hover {
        background: #076eff;
        color: #fff;
    }
}
</style>